module.exports = __webpack_public_path__ + "static/media/cq_info b.929f7e0a.svg";